module.exports = "https://static.im-cdn.com/mjc/storefront/Anchor/static/media/Fpinterest.a8de1786.svg";